const home = {
  infoWindow: {
    area: "地区(府)",
    licencePlate: "车牌",
    title: "车辆信息",
    model: "车型",
    brand: "品牌",
    dataTime: "数据时间",
    gpsSpeed: "GPS车速",
    gpsMileage: "GPS里程",
    monitor: "单车监控",
    obd: "OBD设备号",
    gpsTime: "GPS定位时间",
    series: "车系",
    speed: "车速"
  }
} 
export default home